<template>
    <div class="page"
         v-loading.fullscreen.lock="fullscreenLoading"
         element-loading-text="加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.5)">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small"
                 class="query-form" @submit.native.prevent>
            <el-form-item label="所属账号">
                <GridSelectU style="width: 200px;" title="选择所属账号" labelName="userName"
                             labelValue="id" :value="queryForm.userId" :limit='1' size='small'
                             placeholder='请选择所属账号'
                             @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search"
                             dataListUrl="/mpp/user/findList" entityBeanName="mppUser"
                             queryEntityUrl="/mpp/user/get">
                </GridSelectU>
            </el-form-item>
            <!--            <el-form-item label="子商户号">-->
            <!--                <el-input v-model="queryForm.subAccount" style="width: 200px;"></el-input>-->
            <!--            </el-form-item>-->
            <el-form-item label="组织类型">
                <el-select v-model="queryForm.orgType" style="width: 200px;">
                    <el-option v-for="(item,index) in storeOrgTypeStatusEunmList" :key="index" :value="item.key" :label="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="营业执照名称">
                <el-input style="width: 200px;" v-model="queryForm.licenseName"></el-input>
            </el-form-item>
            <el-form-item label="法人姓名">
                <el-input style="width: 200px;" v-model="queryForm.personName"></el-input>
            </el-form-item>
            <el-form-item label="法人手机">
                <el-input style="width: 200px;" v-model="queryForm.personMobile"></el-input>
            </el-form-item>
            <el-form-item label="是否签约">
                <el-select v-model="queryForm.isSign" style="width: 200px;">
                    <el-option :value="1" label="是"></el-option>
                    <el-option :value="0" label="否"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getShopStorePayHuilianList">查询
                </el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-plus"
                        @click="addShopStorePayHuilian"
                    >新建
                    </el-button>
                    <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1"
                        @click="editShopStorePayHuilian(null)"
                    >修改
                    </el-button>
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteShopStorePayHuilian(null)"
                    >删除
                    </el-button>
                </div>

                <div class="icon-group">
                    <el-upload v-if="this.isImportDate"
                               class="upload-demo"
                               action="#"
                               :http-request="upload"
                               :show-file-list="true">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title="搜索"
                        class="icon-box"
                        @click="search"
                    >
                      <Icon color="#606266">
                        <Search />
                      </Icon>
                    </span>
<!--                    <span
                        title="下载模板"
                        class="icon-box"
                        @click="importTemplate"
                    >
                      <Icon color="#606266">
                        <ArrowDown />
                      </Icon>
                    </span>
                    <span
                        class="icon-box"
                        title="导入数据"
                        @click="isImport"
                    >
                      <Icon color="#606266">
                        <ArrowExportUp24Regular />
                      </Icon>
                    </span>
                    <span
                        title="导出数据"
                        class="icon-box"
                        @click="exportShopStorePayHuilianList"
                    >
                      <Icon color="#606266">
                        <ArrowDownload24Regular />
                      </Icon>
                    </span> -->
                    <span
                        class="icon-box"
                        @click="refreshShopStorePayHuilianList"
                    >
                      <Icon color="#606266">
                        <Refresh />
                      </Icon>
                    </span>
                </div>
            </div>

            <div class="page-content">
                <!--            tab-->
                <el-tabs v-model="tabs" v-if='auditStatusList.length > 0'>

                    <!--添加或减少：移除或添加html结构->移除或添加监听的tabs中switch case
                        修改默认显示：tab栏默认显示tabs的值 想默认显示那个直接把下面的name替换掉
                        queryForm.orderStatus的值为默认请求的类型，空表示全部-->
                    <el-tab-pane label="" name="null"></el-tab-pane>
                    <el-tab-pane :label="'全部'" name="zero"></el-tab-pane>
                    <!--                (${computeAuditStatus[`status_${index}`]})-->
                    <el-tab-pane v-for="(item,index) in auditStatusList" :label="`${item.value}`" :name='"status_"+index'></el-tab-pane>
                </el-tabs>
                <!-- 列表数据 -->
                <el-table
                    :data="shopStorePayHuilianList"
                    row-key="id"
                    border
                    height="100%"
                    :header-row-style="{height: '10px'}"
                    :header-cell-style="{padding: '10px'}"
                    :row-style="{height: '9px'}"
                    @selection-change="handleSelectionChange"
                    size="small"
                >
                    <el-table-column
                        align="center"
                        type="selection"
                        width="60"
                    ></el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="orgType"
                        label="组织类型"
                        width="140"
                    >
                        <template scope="scope">
                            <div v-if="storeOrgTypeStatusEunmList && scope.row && scope.row.orgType">
                                <el-tag size="small" type="danger" v-if="scope.row.orgType == 3">{{returnStoreOrgTypeStatus(scope.row.orgType)}}</el-tag>
                                <el-tag size="small" v-else>{{returnStoreOrgTypeStatus(scope.row.orgType)}}</el-tag>
                            </div>
                            <div v-else>-</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="storeId"
                        label="门店信息"
                        width="240"
                    >
                        <template slot-scope="scope">
                            <div v-if="scope.row.store">
                                <div style="text-align: left">店名：{{scope.row.store.storeName}}</div>
                                <div style="text-align: left">时间：{{scope.row.store.openHours}}</div>
                                <div style="text-align: left">地址：{{scope.row.store.storeAddress}}</div>
                            </div>
                            <div v-else>暂无关联店铺</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="userId"
                        label="用户信息"
                        width="240"
                    >
                        <template scope="scope">
                            <div v-if="scope.row && scope.row.user">
                                <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                                <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                                <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                            </div>
                            <div v-else>暂无关联用户</div>
                        </template>
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" align="center" label="进件状态" width="170">
                        <template slot-scope="scope">
                            <div>
                                <span :class="{'active': scope.row.huilianMerch && scope.row.huilianMerch.thirdStatus == 7}">{{computeAuditStatus(scope.row.huilianMerch ? scope.row.huilianMerch.thirdStatus : 0) }}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" align="center"  label="开通状态" width="200">
                        <template slot-scope="scope">

                            <!--                        <div style="text-align: left">汇联支付审核状态：<span :class="{'active': scope.row.thirdStatus == 2}">{{computeAuditStatus(scope.row.thirdStatus) }}</span></div>-->
                            <div style="text-align: left">微信支付开通状态：<span :class="{'active': scope.row.huilianMerch && scope.row.huilianMerch.openWxpay}">{{ scope.row.huilianMerch && scope.row.huilianMerch.openWxpay == 1 ? '已开通' : '未开通' }}</span></div>
                            <div style="text-align: left">支付宝支付开通状态：<span :class="{'active': scope.row.huilianMerch && scope.row.huilianMerch.openAlipay}">{{ scope.row.huilianMerch && scope.row.huilianMerch.openAlipay == 1 ? '已开通' : '未开通' }}</span></div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="resultMsg"
                        label="进件日志"
                        width="180"
                    >
                        <template slot-scope="scope">
                            <span>{{scope.row.huilianMerch && scope.row.huilianMerch.resultMsg}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" align="center" label="审核失败原因" width="170">
                        <template slot-scope="scope">
                            <div v-if="scope.row.store.status == 3">
                                <span>{{scope.row.store.refuseReason}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="personName"
                        label="法人信息"
                        width="240"
                    >
                        <template scope="scope">
                            <div>
                                <div style="text-align: left">法人：{{scope.row.personName}}</div>
                                <div style="text-align: left">证号：{{scope.row.idCard}}</div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="bankAccount"
                        label="开户行信息"
                        width="240"
                    >
                        <template scope="scope">
                            <div>
                                <div style="text-align: left">行别：{{scope.row.bankName}}</div>
                                <div style="text-align: left">户名：{{scope.row.bankHolder}}</div>
                                <div style="text-align: left">账号：{{scope.row.bankAccount}}</div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="licensePic"
                        label="营业执照图片"
                        width="130"
                    >
                        <template slot-scope="scope">
                            <div v-if='scope.row.licensePic'>
                                <el-image
                                    @click='updateSrcList(scope.row.licensePic)'
                                    style="width: 60px; height: 60px"
                                    :src="scope.row.licensePic"
                                    :preview-src-list="srcList"> </el-image>
                            </div>
                            <div v-else>-</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="idCardFacade"
                        label="身份证正面图片"
                        width="130"
                    >
                        <template slot-scope="scope">
                            <div v-if='scope.row.idCardFacade'>
                                <el-image
                                    @click='updateSrcList(scope.row.idCardFacade)'
                                    style="width: 60px; height: 60px"
                                    :src="scope.row.idCardFacade"
                                    :preview-src-list="srcList"> </el-image>
                            </div>
                            <div v-else>-</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="idCardBack"
                        label="身份证背面图片"
                        width="130"
                    >
                        <template slot-scope="scope">
                            <div v-if='scope.row.idCardBack'>
                                <el-image
                                    @click='updateSrcList(scope.row.idCardBack)'
                                    style="width: 60px; height: 60px"
                                    :src="scope.row.idCardBack"
                                    :preview-src-list="srcList"> </el-image>
                            </div>
                            <div v-else>-</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="bankCardFacade"
                        label="银行卡正面图片"
                        width="130"
                    >
                        <template slot-scope="scope">
                            <div v-if='scope.row.bankCardFacade'>
                                <el-image
                                    @click='updateSrcList(scope.row.bankCardFacade)'
                                    style="width: 60px; height: 60px"
                                    :src="scope.row.bankCardFacade"
                                    :preview-src-list="srcList"> </el-image>
                            </div>
                            <div v-else>-</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="bankCardBack"
                        label="银行卡背面图片"
                        width="130"
                    >
                        <template slot-scope="scope">
                            <div v-if='scope.row.bankCardBack'>
                                <el-image
                                    @click='updateSrcList(scope.row.bankCardBack)'
                                    style="width: 60px; height: 60px"
                                    :src="scope.row.bankCardBack"
                                    :preview-src-list="srcList"> </el-image>
                            </div>
                            <div v-else>-</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="wxpayConfirmQrcode"
                        label="微信确认二维码"
                        width="130"
                    >
                        <template slot-scope="scope">
                            <div v-if='scope.row.huilianMerch && scope.row.huilianMerch.wxpayConfirmQrcode'>
                                <el-image
                                    @click='updateSrcList(scope.row.huilianMerch.wxpayConfirmQrcode)'
                                    style="width: 60px; height: 60px"
                                    :src="scope.row.huilianMerch.wxpayConfirmQrcode"
                                    :preview-src-list="srcList"> </el-image>
                            </div>
                            <div v-else-if="scope.row.huilianMerch && scope.row.huilianMerch.wxpayAuthStatus == 5">驳回，请查看报文</div>
                            <div v-else>-</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="alipayConfirmQrcode"
                        label="支付宝确认二维码"
                        width="144"
                    >
                        <template slot-scope="scope">
                            <div v-if='scope.row.huilianMerch && scope.row.huilianMerch.alipayConfirmQrcode'>
                                <el-image
                                    @click='updateSrcList(scope.row.huilianMerch.alipayConfirmQrcode)'
                                    style="width: 60px; height: 60px"
                                    :src="scope.row.huilianMerch.alipayConfirmQrcode"
                                    :preview-src-list="srcList"> </el-image>
                            </div>
                            <div v-else-if="scope.row.huilianMerch && scope.row.huilianMerch.alipayAuthStatus == 5">驳回，请查看报文</div>
                            <div v-else>-</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="createTime"
                        label="创建时间"
                        width="180"
                    >
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        align="center"
                        label="操作"
                        width="300"
                    >
                        <template slot-scope="scop">
                            <div class="operation">
                                <div @click='ShopStoreAudit(scop.row)' v-if='scop.row.store.status == 1'>
                                    <el-button type='primary' size='mini'>审核</el-button>
                                </div>
                                <div @click="checkShopStorePayHuilian(scop.row.id)">
                                    <Icon size="16">
                                        <Eye24Regular />
                                    </Icon>
                                    <span class="operation-label">查看</span>
                                </div>
                                <div @click="editShopStorePayHuilian(scop.row.id)">
                                    <Icon size="16">
                                        <Edit24Regular />
                                    </Icon>
                                    <span class="operation-label">修改</span>
                                </div>
                                <div @click="deleteShopStorePayHuilian(scop.row.id)">
                                    <Icon size="16" style="color: red">
                                        <Delete24Regular />
                                    </Icon>
                                    <span class="operation-label" style="color: red">删除</span>
                                </div>
                            </div>
                            <div class="operation">
                                <div @click="submitMerchantInfo(scop.row.storeId)" v-if="scop.row.huilianMerch && scop.row.huilianMerch.thirdStatus == 0">
                                    <span class="operation-label">提交进件资料</span>
                                </div>
<!--                                <div @click="applyElectronContract(scop.row.storeId)" v-if="scop.row.huilianMerch && scop.row.huilianMerch.thirdStatus == 2">-->
<!--                                    <span class="operation-label">申请签约</span>-->
<!--                                </div>-->
<!--                                <div @click="openMerchantSplitOrder(scop.row.storeId)" v-if="scop.row.huilianMerch && scop.row.huilianMerch.thirdStatus == 4 && scop.row.huilianMerch.openSplitOrder != 1">-->
<!--                                    <span class="operation-label">开通分账</span>-->
<!--                                </div>-->
<!--                                <div @click="wxAuthentication(scop.row.storeId)">-->
<!--                                    <span class="operation-label" v-if="scop.row.huilianMerch && scop.row.huilianMerch.thirdStatus == 10 && scop.row.huilianMerch.openWxpay == 0">微信认证提交</span>-->
<!--                                </div>-->
<!--                                <div @click="aliAuthentication(scop.row.storeId)">-->
<!--                                    <span class="operation-label" v-if="scop.row.huilianMerch && scop.row.huilianMerch.thirdStatus == 10 && scop.row.huilianMerch.openAlipay == 0">支付宝认证提交</span>-->
<!--                                </div>-->
                                <div @click="submitAcctAccount(scop.row.storeId)">
                                    <span class="operation-label" v-if="scop.row.huilianMerch && scop.row.huilianMerch.thirdStatus == 10">非收单会员登记</span>
                                </div>
<!--                                <div @click="editAcctAccount(scop.row.storeId)">-->
<!--                                    <span class="operation-label" v-if="scop.row.huilianMerch && scop.row.huilianMerch.splitMerchNo">非收单会员信息变更</span>-->
<!--                                </div>-->
                                <div @click="merchantBasicdataModify(scop.row.storeId)">
                                    <span class="operation-label" v-if="scop.row.huilianMerch && scop.row.huilianMerch.thirdStatus == 11">提交修改资料</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination-box">
                    <el-pagination
                        @size-change="sizeChange"
                        @current-change="currentChange"
                        :current-page.sync="currentPage"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalNum"
                        background
                        :pager-count="7"
                    >
                    </el-pagination>
                </div>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="shopStorePayHuilianStates[shopStorePayHuilianState] + `${shopStorePayHuilian.huilianMerch ? '-' : ''}`"
                :visible.sync="showDialog"
                width="1200px"
                @close="closeDialog"
            >
                <div>
                    <el-form
                        :model="shopStorePayHuilian"
                        ref="shopStorePayHuilianForm"
                        :rules="rules"
                        label-width="150px"
                        :inline="true"
                        size="small"
                    >
                        <el-tabs type="border-card">
                            <el-tab-pane label="工商信息">
                                <div style="display: flex">
                                    <div class="left" style="flex: 2;flex-shrink: 0;margin-right: 10px">
                                        <div style="display: flex;align-items: center;justify-content: center;margin-bottom: 10px;border-bottom: 1px solid #ccc; padding-bottom: 8px">
                                            <span style="font-size: 16px;font-weight: 700">本地信息</span>
                                        </div>
                                        <el-form-item
                                            label="组织类型"
                                            prop="orgType"
                                        >
                                            <el-select
                                                v-model="shopStorePayHuilian.orgType"
                                                size="small"
                                                placeholder="请选择组织类型"
                                                clearable
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                            >
                                                <el-option v-for="(item,index) in storeOrgTypeStatusEunmList" :label="item.value" :value="item.key"> </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="执照所属省份"
                                            prop="licenseProvinceId"
                                        >
                                            <el-select
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                v-model='shopStorePayHuilian.licenseProvinceId'
                                                size='small'
                                                placeholder='请选择省份'
                                            >
                                                <el-option
                                                    v-for='item in provinceIdList'
                                                    :key='item.id'
                                                    :label='item.name'
                                                    :value='item.id'
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="执照所属城市"
                                            prop="licenseCityId"
                                        >
                                            <el-select
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                v-model='shopStorePayHuilian.licenseCityId'
                                                size='small'
                                                placeholder='请选择城市'
                                            >
                                                <el-option
                                                    v-for='item in cityIdList'
                                                    :key='item.id'
                                                    :label='item.name'
                                                    :value='item.id'
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="执照所属区县"
                                            prop="licenseAreaId"
                                        >
                                            <el-select
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                v-model='shopStorePayHuilian.licenseAreaId'
                                                size='small'
                                                placeholder='请选择区县'
                                            >
                                                <el-option
                                                    v-for='item in areaIdList'
                                                    :key='item.id'
                                                    :label='item.name'
                                                    :value='item.id'
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="执照所属乡镇"
                                            prop="licenseTownId"
                                        >
                                            <el-select
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                v-model='shopStorePayHuilian.licenseTownId'
                                                size='small'
                                                placeholder='请选择乡镇'
                                            >
                                                <el-option
                                                    v-for='item in streetIdList'
                                                    :key='item.id'
                                                    :label='item.name'
                                                    :value='item.id'
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="营业执照名称"
                                            prop="licenseName"
                                        >
                                            <el-input
                                                size="small"
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                v-model="shopStorePayHuilian.licenseName"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="营业执照注册地址"
                                            prop="licenseAddress"
                                        >
                                            <el-input
                                                size="small"
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                v-model="shopStorePayHuilian.licenseAddress"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="统一社会信用代码"
                                            prop="licenseNumber"
                                        >
                                            <el-input
                                                size="small"
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                v-model="shopStorePayHuilian.licenseNumber"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="营业执照注册资本"
                                            prop="licenseRegCapital"
                                        >
                                            <el-input
                                                size="small"
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                v-model="shopStorePayHuilian.licenseRegCapital"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="经营期限起始"
                                            prop="licenseStartTime"
                                        >
                                            <div style="width: 200px;display: flex;align-items: center;">
                                                <el-date-picker
                                                    style="width: 200px"
                                                    :disabled="shopStorePayHuilianState == 'check'"
                                                    size="small"
                                                    v-model="shopStorePayHuilian.licenseStartTime"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="选择日期">
                                                </el-date-picker>
                                                <el-checkbox style="margin-left: 10px" :disabled="shopStorePayHuilianState == 'check'" :true-label="1" :false-label="0" v-model="shopStorePayHuilian.licenseIsPermanent" label="长期"></el-checkbox>
                                            </div>

                                        </el-form-item>
                                        <el-form-item
                                            label="经营期限结束"
                                            prop="licenseEndTime"
                                            v-if="shopStorePayHuilian.licenseIsPermanent == 0"
                                        >
                                            <el-date-picker
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                size="small"
                                                v-model="shopStorePayHuilian.licenseEndTime"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                placeholder="选择日期">
                                            </el-date-picker>
                                        </el-form-item>
                                        <el-form-item
                                            label="经营范围"
                                            prop="licenseRange"
                                        >
                                            <el-input
                                                size="small"
                                                type="textarea"
                                                :rows="8"
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                v-model="shopStorePayHuilian.licenseRange"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="营业执照图片"
                                            prop="licensePic"
                                        >
                                            <div style="width: 200px;display: flex;">
                                                <el-upload :disabled="shopStorePayHuilianState == 'check'" :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                           class="avatar-uploader" :show-file-list="false"
                                                           :http-request="uploadImage21">
                                                    <img v-if="shopStorePayHuilian.licensePic" :src="shopStorePayHuilian.licensePic" class="avatar" size="small" />
                                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>
                                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStorePayHuilian.licensePic)">查看</el-button>
                                            </div>
                                        </el-form-item>
                                    </div>
                                    <div class="right" style="flex: 1;flex-shrink: 0;margin-left: 10px">
                                        <div style="display: flex;align-items: center;justify-content: center;margin-bottom: 10px;border-bottom: 1px solid #ccc; padding-bottom: 8px">
                                            <span style="font-size: 16px;font-weight: 700">汇联信息</span>
                                        </div>
                                        <el-form-item
                                            label="行业代码"
                                            prop="huilianMerch.mccCode"
                                        >
                                            <el-input
                                                size="small"
                                                style="width: 200px"
                                                readonly
                                                v-model="shopStorePayHuilian.huilianMerch.mccName"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                            >
                                                <el-button @click="getMccCode()" slot="append" icon="el-icon-search"></el-button>
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="收单机构对应的省"
                                            prop="huilianMerch.acqProvinceId"
                                        >
                                            <el-select
                                                style='width:200px'
                                                v-model='shopStorePayHuilian.huilianMerch.acqProvinceId'
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                size='small'
                                                placeholder='请选择省份'
                                            >
                                                <el-option
                                                    v-for='item in provinceIdList3'
                                                    :key='item.id'
                                                    :label='item.name'
                                                    :value='item.code'
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="收单机构对应的市"
                                            prop="huilianMerch.acqCityId"
                                        >
                                            <el-select
                                                style='width:200px'
                                                v-model='shopStorePayHuilian.huilianMerch.acqCityId'
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                size='small'
                                                placeholder='请选择城市'
                                            >
                                                <el-option
                                                    v-for='item in cityIdList3'
                                                    :key='item.id'
                                                    :label='item.name'
                                                    :value='item.code'
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="收单机构对应的区"
                                            prop="huilianMerch.acqAreaId"
                                        >
                                            <el-select
                                                style='width:200px'
                                                v-model='shopStorePayHuilian.huilianMerch.acqAreaId'
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                size='small'
                                                placeholder='请选择区县'
                                            >
                                                <el-option
                                                    v-for='item in areaIdList3'
                                                    :key='item.id'
                                                    :label='item.name'
                                                    :value='item.code'
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="法人信息">
                                <div style="display: flex">
                                    <div class="left" style="flex: 2;flex-shrink: 0;margin-right: 10px">
                                        <div style="display: flex;align-items: center;justify-content: center;margin-bottom: 10px;border-bottom: 1px solid #ccc; padding-bottom: 8px">
                                            <span style="font-size: 16px;font-weight: 700">本地信息</span>
                                        </div>
                                        <!--                                        左边-->
                                        <el-form-item
                                            label="法人姓名"
                                            prop="personName"
                                        >
                                            <el-input
                                                size="small"
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                v-model="shopStorePayHuilian.personName"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="身份证号"
                                            prop="idCard"
                                        >
                                            <el-input
                                                size="small"
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                v-model="shopStorePayHuilian.idCard"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="证件有效期起始"
                                            prop="idCardStartTime"
                                        >
                                            <div style="width: 200px;display: flex;align-items: center">
                                                <el-date-picker
                                                    style="flex: 1"
                                                    size="small"
                                                    :disabled="shopStorePayHuilianState == 'check'"
                                                    v-model="shopStorePayHuilian.idCardStartTime"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="选择日期">
                                                </el-date-picker>
                                                <el-checkbox style="margin-left: 10px" :disabled="shopStorePayHuilianState == 'check'" :true-label="1" :false-label="0" v-model="shopStorePayHuilian.idCardIsPermanent" label="长期"></el-checkbox>
                                            </div>
                                        </el-form-item>
                                        <el-form-item
                                            label="证件有效期结束"
                                            prop="idCardEndTime"
                                            v-if="shopStorePayHuilian.idCardIsPermanent==0"
                                        >
                                            <el-date-picker
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                size="small"
                                                v-model="shopStorePayHuilian.idCardEndTime"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                placeholder="选择日期">
                                            </el-date-picker>
                                        </el-form-item>
                                        <el-form-item
                                            label="证件地址"
                                            prop="idCardAddress"
                                        >
                                            <el-input
                                                size="small"
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                v-model="shopStorePayHuilian.idCardAddress"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="身份证人像面图片"
                                            prop="idCardFacade"
                                        >
                                            <div style="display: flex;width: 200px;">
                                                <el-upload :disabled="shopStorePayHuilianState == 'check'" :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                           class="avatar-uploader" :show-file-list="false"
                                                           :http-request="uploadImage31">
                                                    <img v-if="shopStorePayHuilian.idCardFacade" :src="shopStorePayHuilian.idCardFacade" class="avatar" size="small" />
                                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>
                                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStorePayHuilian.idCardFacade)">查看</el-button>
                                            </div>
                                        </el-form-item>
                                        <el-form-item
                                            label="身份证国徽面图片"
                                            prop="idCardBack"
                                        >
                                            <div style="display: flex;width: 200px;">
                                                <el-upload :disabled="shopStorePayHuilianState == 'check'" :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                           class="avatar-uploader" :show-file-list="false"
                                                           :http-request="uploadImage32">
                                                    <img v-if="shopStorePayHuilian.idCardBack" :src="shopStorePayHuilian.idCardBack" class="avatar" size="small" />
                                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>
                                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStorePayHuilian.idCardBack)">查看</el-button>
                                            </div>
                                        </el-form-item>
                                    </div>
                                    <!--                                    <div class="right" style="flex: 1;flex-shrink: 0;margin-left: 10px">-->
                                    <!--                                        <div style="display: flex;align-items: center;justify-content: center;margin-bottom: 10px">-->
                                    <!--                                            <span style="font-size: 16px;font-weight: 700">汇联信息</span>-->
                                    <!--                                        </div>-->
                                    <!--                                    </div>-->
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="银行信息">
                                <div style="display: flex">
                                    <div class="left" style="flex: 2;flex-shrink: 0;margin-right: 10px">
                                        <div style="display: flex;align-items: center;justify-content: center;margin-bottom: 10px;border-bottom: 1px solid #ccc; padding-bottom: 8px">
                                            <span style="font-size: 16px;font-weight: 700">本地信息</span>
                                        </div>
                                        <!--                                        左边-->
                                        <el-form-item
                                            label="对公账户名称/持有人姓名"
                                            prop="bankHolder"
                                        >
                                            <el-input
                                                size="small"
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                v-model="shopStorePayHuilian.bankHolder"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="对公账户卡号/银行卡卡号"
                                            prop="bankAccount"
                                        >
                                            <el-input
                                                size="small"
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                v-model="shopStorePayHuilian.bankAccount"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="所属银行"
                                            prop="bankName"
                                        >
                                            <el-input
                                                size="small"
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                v-model="shopStorePayHuilian.bankName"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="银行联号"
                                            prop="bankBranchCode"
                                        >
                                            <GridSelectLi
                                                style="width: 200px;"
                                                title="选择银行联号"
                                                :resultObj="true"
                                                labelName="id"
                                                labelValue="id"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                :value="shopStorePayHuilian.bankBranchCode"
                                                :limit="1"
                                                size="small"
                                                placeholder="请选择银行联号"
                                                @getValue="getBankBranchCode"
                                                :columns="[{prop: 'id',label: '银行联号'},{prop: 'bankName',label: '开户支行'}]"
                                                :searchs="[{prop: 'bankName',label: '开户支行'}]"
                                                dataListUrl="/shop/storebank/findList"
                                                entityBeanName="shopStoreBank"
                                                queryEntityUrl="/shop/storebank/get"
                                            >
                                            </GridSelectLi>
                                        </el-form-item>
                                        <el-form-item
                                            label="开户支行"
                                            prop="bankSubbranch"
                                        >
                                            <el-input
                                                size="small"
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                v-model="shopStorePayHuilian.bankSubbranch"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="银行所在省份"
                                            prop="bankProvinceId"
                                        >
                                            <el-select
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                v-model='shopStorePayHuilian.bankProvinceId'
                                                size='small'
                                                placeholder='请选择省份'
                                            >
                                                <el-option
                                                    v-for='item in provinceIdList'
                                                    :key='item.id'
                                                    :label='item.name'
                                                    :value='item.id'
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="银行所在城市"
                                            prop="bankCityId"
                                        >
                                            <el-select
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                v-model='shopStorePayHuilian.bankCityId'
                                                size='small'
                                                placeholder='请选择城市'
                                            >
                                                <el-option
                                                    v-for='item in cityIdList2'
                                                    :key='item.id'
                                                    :label='item.name'
                                                    :value='item.id'
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="银行所在区县"
                                            prop="bankAreaId"
                                        >
                                            <el-select
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                v-model='shopStorePayHuilian.bankAreaId'
                                                size='small'
                                                placeholder='请选择区县'
                                            >
                                                <el-option
                                                    v-for='item in areaIdList2'
                                                    :key='item.id'
                                                    :label='item.name'
                                                    :value='item.id'
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="银行预留手机号"
                                            prop="bankMobile"
                                        >
                                            <el-input
                                                size="small"
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                v-model="shopStorePayHuilian.bankMobile"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="银行卡正面图片"
                                            prop="bankCardFacade"
                                            v-if="shopStorePayHuilian.orgType != 2"
                                        >
                                            <div style="display: flex;width: 200px;">
                                                <el-upload :disabled="shopStorePayHuilianState == 'check'" :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                           class="avatar-uploader" :show-file-list="false"
                                                           :http-request="uploadImage41">
                                                    <img v-if="shopStorePayHuilian.bankCardFacade" :src="shopStorePayHuilian.bankCardFacade" class="avatar" size="small" />
                                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>
                                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStorePayHuilian.bankCardFacade)">查看</el-button>
                                            </div>
                                        </el-form-item>
                                        <el-form-item
                                            label="银行卡背面图片"
                                            prop="bankCardBack"
                                            v-if="shopStorePayHuilian.orgType != 2"
                                        >
                                            <div style="display: flex;width: 200px;">
                                                <el-upload :disabled="shopStorePayHuilianState == 'check'" :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                           class="avatar-uploader" :show-file-list="false"
                                                           :http-request="uploadImage42">
                                                    <img v-if="shopStorePayHuilian.bankCardBack" :src="shopStorePayHuilian.bankCardBack" class="avatar" size="small" />
                                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>
                                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStorePayHuilian.bankCardBack)">查看</el-button>
                                            </div>
                                        </el-form-item>
                                        <el-form-item
                                            label="对公账户凭证"
                                            prop="bankAccountVoucher"
                                            v-if="shopStorePayHuilian.orgType == 2"
                                        >
                                            <div style="display: flex;width: 200px;">
                                                <el-upload :disabled="shopStorePayHuilianState == 'check'" :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                           class="avatar-uploader" :show-file-list="false"
                                                           :http-request="uploadImage43">
                                                    <img v-if="shopStorePayHuilian.bankAccountVoucher" :src="shopStorePayHuilian.bankAccountVoucher" class="avatar" size="small" />
                                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>
                                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStorePayHuilian.bankAccountVoucher)">查看</el-button>
                                            </div>
                                        </el-form-item>
                                    </div>
                                    <div class="right" style="flex: 1;flex-shrink: 0;margin-left: 10px">
                                        <div style="display: flex;align-items: center;justify-content: center;margin-bottom: 10px;border-bottom: 1px solid #ccc; padding-bottom: 8px">
                                            <span style="font-size: 16px;font-weight: 700">汇联信息</span>
                                        </div>
                                        <el-form-item
                                            label="收单机构银行对应的省"
                                            prop="huilianMerch.acqBankProvinceId"
                                        >
                                            <el-select
                                                style='width:200px'
                                                v-model='shopStorePayHuilian.huilianMerch.acqBankProvinceId'
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                size='small'
                                                placeholder='请选择省份'
                                            >
                                                <el-option
                                                    v-for='item in provinceIdList3'
                                                    :key='item.id'
                                                    :label='item.name'
                                                    :value='item.code'
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="收单机构银行对应的市"
                                            prop="huilianMerch.acqBankCityId"
                                        >
                                            <el-select
                                                style='width:200px'
                                                v-model='shopStorePayHuilian.huilianMerch.acqBankCityId'
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                size='small'
                                                placeholder='请选择城市'
                                            >
                                                <el-option
                                                    v-for='item in cityIdList4'
                                                    :key='item.id'
                                                    :label='item.name'
                                                    :value='item.code'
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="收单机构银行对应的区"
                                            prop="huilianMerch.acqBankAreaId"
                                        >
                                            <el-select
                                                style='width:200px'
                                                v-model='shopStorePayHuilian.huilianMerch.acqBankAreaId'
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                size='small'
                                                placeholder='请选择区县'
                                            >
                                                <el-option
                                                    v-for='item in areaIdList4'
                                                    :key='item.id'
                                                    :label='item.name'
                                                    :value='item.code'
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
<!--                                        <el-form-item-->
<!--                                            label="收单机构行别code"-->
<!--                                            prop="huilianMerch.acqBankCode"-->
<!--                                        >-->
<!--                                            <GridSelectLi-->
<!--                                                style="width: 200px;"-->
<!--                                                title="选择行别code"-->
<!--                                                :resultObj="true"-->
<!--                                                labelName="id"-->
<!--                                                labelValue="id"-->
<!--                                                :disabled="shopStorePayHuilianState == 'check'"-->
<!--                                                :value="shopStorePayHuilian.huilianMerch.acqBankCode"-->
<!--                                                :limit="1"-->
<!--                                                size="small"-->
<!--                                                placeholder="请选择行别code"-->
<!--                                                @getValue="getAcqBankNameId"-->
<!--                                                :columns="[{prop: 'id',label: '行别code'},{prop: 'bankName',label: '行别'}]"-->
<!--                                                :searchs="[{prop: 'bankName',label: '行别'}]"-->
<!--                                                dataListUrl="/shop/storepayHuilianbank/findList"-->
<!--                                                entityBeanName="shopStorePayHuilianBank"-->
<!--                                                queryEntityUrl="/shop/storepayHuilianbank/get"-->
<!--                                            >-->
<!--                                            </GridSelectLi>-->
<!--                                        </el-form-item>-->
<!--                                        <el-form-item-->
<!--                                            label="收单机构银行行别"-->
<!--                                            prop="huilianMerch.acqBankName"-->
<!--                                        >-->
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                style="width: 200px"-->
<!--                                                :disabled="shopStorePayHuilianState == 'check'"-->
<!--                                                v-model="shopStorePayHuilian.huilianMerch.acqBankName"-->
<!--                                            ></el-input>-->
<!--                                        </el-form-item>-->
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="认证信息">
                                <div style="display: flex">
                                    <div class="left" style="flex: 2;flex-shrink: 0;margin-right: 10px">
                                        <div style="display: flex;align-items: center;justify-content: center;margin-bottom: 10px;border-bottom: 1px solid #ccc; padding-bottom: 8px">
                                            <span style="font-size: 16px;font-weight: 700">汇联信息</span>
                                        </div>
                                        <!--                                        左边-->
                                        <el-form-item
                                            label="进件状态"
                                            prop="huilianMerch.thirdStatus"
                                        >
                                            <el-select
                                                v-model="shopStorePayHuilian.huilianMerch.thirdStatus"
                                                size="small"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                placeholder="请选择进件状态"
                                                clearable
                                                style="width: 200px"
                                            >
                                                <el-option v-for="(item,index) in auditStatusList" :label="item.value" :value="item.key"> </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="第三方支付子商户号"
                                            prop="huilianMerch.subAccount"
                                        >
                                            <el-input
                                                size="small"
                                                style="width: 200px"
                                                v-model="shopStorePayHuilian.huilianMerch.subAccount"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="微信支付开关"
                                            prop="huilianMerch.openWxpay"
                                        >
                                            <!--                                            <el-input-->
                                            <!--                                                size="small"-->
                                            <!--                                                v-model="shopStorePayHuilian.openWxpay"-->
                                            <!--                                                style="width: 200px"-->
                                            <!--                                                :disabled="shopStorePayHuilianState == 'check'"-->
                                            <!--                                            ></el-input>-->
                                            <el-select
                                                v-model="shopStorePayHuilian.huilianMerch.openWxpay"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                size="small"
                                                placeholder="请选择微信支付是否开启"
                                                clearable
                                                style="width: 200px"
                                            >
                                                <el-option label="是" :value="1"> </el-option>
                                                <el-option label="否" :value="0"> </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="微信申请单编号"
                                            prop="huilianMerch.wxpayApplyNo"
                                        >
                                            <el-input
                                                size="small"
                                                v-model="shopStorePayHuilian.huilianMerch.wxpayApplyNo"
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="微信商户号"
                                            prop="huilianMerch.wxpayMerchNo"
                                        >
                                            <el-input
                                                size="small"
                                                v-model="shopStorePayHuilian.huilianMerch.wxpayMerchNo"
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="微信法人确认二维码"
                                            prop="huilianMerch.wxpayConfirmQrcode"
                                        >
                                            <div style="display:flex;width: 200px;">
                                                <el-upload :disabled="shopStorePayHuilianState == 'check'" :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                           class="avatar-uploader" :show-file-list="false"
                                                           :http-request="uploadImage52">
                                                    <img v-if="shopStorePayHuilian.huilianMerch.wxpayConfirmQrcode" :src="shopStorePayHuilian.huilianMerch.wxpayConfirmQrcode" class="avatar" size="small" />
                                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>
                                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStorePayHuilian.huilianMerch.wxpayConfirmQrcode)">查看</el-button>
                                            </div>

                                        </el-form-item>

                                        <el-form-item
                                            label="支付宝支付开关"
                                            prop="huilianMerch.openAlipay"
                                        >
                                            <el-select
                                                v-model="shopStorePayHuilian.huilianMerch.openAlipay"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                                size="small"
                                                placeholder="请选择支付宝支付是否开启"
                                                clearable
                                                style="width: 200px"
                                            >
                                                <el-option label="是" :value="1"> </el-option>
                                                <el-option label="否" :value="0"> </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="支付宝申请单编号"
                                            prop="huilianMerch.alipayApplyNo"
                                        >
                                            <el-input
                                                size="small"
                                                v-model="shopStorePayHuilian.huilianMerch.alipayApplyNo"
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="支付宝商户号"
                                            prop="huilianMerch.alipayMerchNo"
                                        >
                                            <el-input
                                                size="small"
                                                v-model="shopStorePayHuilian.huilianMerch.alipayMerchNo"
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="支付宝法人确认二维码"
                                            prop="huilianMerch.alipayConfirmQrcode"
                                        >
                                            <div style="display:flex;width: 200px;">
                                                <el-upload :disabled="shopStorePayHuilianState == 'check'" :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                           class="avatar-uploader" :show-file-list="false"
                                                           :http-request="uploadImage54">
                                                    <img v-if="shopStorePayHuilian.huilianMerch.alipayConfirmQrcode" :src="shopStorePayHuilian.huilianMerch.alipayConfirmQrcode" class="avatar" size="small" />
                                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>
                                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStorePayHuilian.huilianMerch.alipayConfirmQrcode)">查看</el-button>
                                            </div>
                                        </el-form-item>
                                        <el-form-item
                                            label="进件日志"
                                            prop="huilianMerch.resultMsg"
                                        >
                                            <el-input
                                                size="small"
                                                type="textarea"
                                                :rows="8"
                                                style="width: 200px"
                                                v-model="shopStorePayHuilian.huilianMerch.resultMsg"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                            ></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="签约信息">
                                <div style="display: flex">
                                    <div class="left" style="flex: 2;flex-shrink: 0;margin-right: 10px">
                                        <div style="display: flex;align-items: center;justify-content: center;margin-bottom: 10px;border-bottom: 1px solid #ccc; padding-bottom: 8px">
                                            <span style="font-size: 16px;font-weight: 700">本地信息</span>
                                        </div>
                                        <el-form-item
                                            label="是否签约"
                                            prop="isSign"
                                        >
                                            <el-select
                                                size="small"
                                                v-model="shopStorePayHuilian.isSign"
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                            >
                                                <el-option :value="0" label="未签约"></el-option>
                                                <el-option :value="1" label="已签约"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="签名图片"
                                            prop="signPic"
                                        >
                                            <div style="display: flex;width: 200px;">
                                                <el-upload :disabled="shopStorePayHuilianState == 'check'" :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                           class="avatar-uploader" :show-file-list="false"
                                                           :http-request="uploadImage61">
                                                    <img v-if="shopStorePayHuilian.signPic" :src="shopStorePayHuilian.signPic" class="avatar" size="small" />
                                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>
                                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStorePayHuilian.signPic)">查看</el-button>
                                            </div>
                                        </el-form-item>
                                        <el-form-item
                                            label="合同详情"
                                            prop="contractUrl"
                                        >
                                            <div style="display: flex;width: 200px;">
                                                <el-upload :disabled="shopStorePayHuilianState == 'check'" :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                           class="avatar-uploader" :show-file-list="false"
                                                           :http-request="uploadImage62">
                                                    <img v-if="shopStorePayHuilian.contractUrl" :src="shopStorePayHuilian.contractUrl" class="avatar" size="small" />
                                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>
                                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStorePayHuilian.contractUrl)">查看</el-button>
                                            </div>
                                        </el-form-item>
                                    </div>
                                    <div class="right" style="flex: 1;flex-shrink: 0;margin-right: 10px">
                                        <div style="display: flex;align-items: center;justify-content: center;margin-bottom: 10px;border-bottom: 1px solid #ccc; padding-bottom: 8px">
                                            <span style="font-size: 16px;font-weight: 700">汇联信息</span>
                                        </div>
                                        <el-form-item
                                            label="收单机构门户网站账号邮箱"
                                            prop="huilianMerch.acqPortalEmail"
                                        >
                                            <el-input
                                                size="small"
                                                v-model="shopStorePayHuilian.huilianMerch.acqPortalEmail"
                                                style="width: 140px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                            ></el-input>
                                            <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getStoreEmail">默认</el-button>
                                        </el-form-item>
                                        <el-form-item
                                            label="收单机构电子协议签约地址"
                                            prop="huilianMerch.elecAgrmtUrl"
                                        >
                                            <el-input
                                                size="small"
                                                v-model="shopStorePayHuilian.huilianMerch.elecAgrmtUrl"
                                                style="width: 200px"
                                                :disabled="shopStorePayHuilianState == 'check'"
                                            ></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                        <el-image ref="images" v-show="false" @click='updateSrcList(imageSrc)' style="width: 60px; height: 60px"
                                  :src="imageSrc" :preview-src-list="srcList"> </el-image>
                    </el-form>
                </div>

                <div
                    slot="footer"
                    class="flex justify-self-end"
                >
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button
                        type="primary"
                        @click="submitForm"
                        v-if="shopStorePayHuilianState != 'check'"
                    >确定
                    </el-button>
                </div>
            </el-dialog>
        </div>

        <!--审核功能-->
        <el-dialog title='审核' :visible.sync='retreatDialogVisible' width='30%'
                   :before-close='handleCloseRetreat'>
            <el-form ref='retreatForm' :rules='retreatRules' size='small' :model='retreatForm' label-width='100px'>
                <el-form-item label='申请说明：'>
                    <el-input style='width: 100%' type='textarea' v-model='applyRemarks'
                              :disabled='true'></el-input>
                </el-form-item>
                <el-form-item label='是否同意：' prop='resource'>
                    <el-radio-group v-model='retreatForm.resource'>
                        <el-radio label='true'>同意</el-radio>
                        <el-radio label='false'>拒绝</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label='驳回原因：' prop='desc' v-if="retreatForm.resource == 'false'">
                    <el-input style='width: 100%' type='textarea' v-model='retreatForm.desc'></el-input>
                </el-form-item>
                <!--                <el-form-item label='收益比例：' v-if="retreatForm.resource == 'true'" prop='incomeRatio'>-->
                <!--                    <el-input style='width: 200px' v-model='retreatForm.incomeRatio'></el-input>-->
                <!--                </el-form-item>-->
            </el-form>
            <span slot='footer' class='dialog-footer'>
                <el-button @click='handleCloseRetreat'>取 消</el-button>
                <el-button type='primary' @click="retreatSuccess('retreatForm')">确 定</el-button>
            </span>
        </el-dialog>

        <mccCide ref="mccCode" @radioItem="radioThis"></mccCide>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import {
    exprotExcel,
    importTemplate,
    importDate,
    get,
    post,
    put,
    deleteFun,
    upload,
    postJson
} from '@/utils/request.js';
import mccCide from '@/components/mccCodeTable/mccCide.vue';
import { UPLOAD_API, UPLOAD_PATH, USER, USER_SEARCH } from '@/utils/constant';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
import GridSelectU from '@/components/gridselect/index.vue';


export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        mccCide,
        GridSelectLi
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopStorePayHuilianList();
                this.getShopStorePayHuilianList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopStorePayHuilianList();
                this.getShopStorePayHuilianList();
                this.$emit('resetCheckState');
            }
        },
        //市
        'shopStorePayHuilian.licenseProvinceId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getCity) {
                    this.shopStorePayHuilian.licenseCityId = '';
                    this.shopStorePayHuilian.licenseAreaId = '';
                    this.shopStorePayHuilian.licenseTownId = '';
                } else {
                    this.getCity = !this.getCity;
                }
                this.getAddress(2,id)
            }, 5);
        },
        //区
        'shopStorePayHuilian.licenseCityId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getArea) {
                    this.shopStorePayHuilian.licenseAreaId = '';
                    this.shopStorePayHuilian.licenseTownId = '';
                } else {
                    this.getArea = !this.getArea;
                }
                this.getAddress(3,id)
            }, 10);
        },
        //社区
        'shopStorePayHuilian.licenseAreaId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.street) {
                    this.shopStorePayHuilian.licenseTownId = '';
                } else {
                    this.street = !this.street;
                }
                this.getAddress(4,id)
            }, 15);
        },
        //市
        'shopStorePayHuilian.bankProvinceId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getCity2) {
                    this.shopStorePayHuilian.bankCityId = '';
                    this.shopStorePayHuilian.bankAreaId = '';
                    this.shopStorePayHuilian.bankTownId = '';
                } else {
                    this.getCity2 = !this.getCity2;
                }
                this.getAddress2(2,id)
            }, 25);
        },
        //区
        'shopStorePayHuilian.bankCityId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getArea2) {
                    this.shopStorePayHuilian.bankAreaId = '';
                    this.shopStorePayHuilian.bankTownId = '';
                } else {
                    this.getArea2 = !this.getArea2;
                }
                this.getAddress2(3,id)
            }, 30);
        },
        //社区
        'shopStorePayHuilian.bankAreaId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.street2) {
                    this.shopStorePayHuilian.bankTownId = '';
                } else {
                    this.street2 = !this.street2;
                }
                this.getAddress2(4,id)
            }, 35);
        },
        //市
        'shopStorePayHuilian.huilianMerch.acqProvinceId'(id) {
            if(!id){
                return;
            }
            let str = ""
            for (let i = 0; i < this.provinceIdList3.length; i++) {
                if(this.provinceIdList3[i].code == id){
                    str = this.provinceIdList3[i].id
                }
            }
            setTimeout(() => {
                if (!this.getCity3) {
                    this.shopStorePayHuilian.huilianMerch.acqCityId = '';
                    this.shopStorePayHuilian.huilianMerch.acqAreaId = '';
                } else {
                    this.getCity3 = !this.getCity3;
                }
                this.getAddress3(2,str)
            }, 25);
        },
        //区
        'shopStorePayHuilian.huilianMerch.acqCityId'(id) {
            if(!id){
                return;
            }
            let str = ""
            for (let i = 0; i < this.cityIdList3.length; i++) {
                if(this.cityIdList3[i].code == id){
                    str = this.cityIdList3[i].id
                }
            }
            setTimeout(() => {
                if (!this.getArea3) {
                    this.shopStorePayHuilian.huilianMerch.acqAreaId = '';
                } else {
                    this.getArea3 = !this.getArea3;
                }
                this.getAddress3(3,str)
            }, 30);
        },
        //市
        'shopStorePayHuilian.huilianMerch.acqBankProvinceId'(id) {
            if(!id){
                return;
            }
            let str = ""
            for (let i = 0; i < this.provinceIdList3.length; i++) {
                if(this.provinceIdList3[i].code == id){
                    str = this.provinceIdList3[i].id
                }
            }
            setTimeout(() => {
                if (!this.getCity4) {
                    this.shopStorePayHuilian.huilianMerch.acqBankCityId = '';
                    this.shopStorePayHuilian.huilianMerch.acqBankAreaId = '';
                } else {
                    this.getCity4 = !this.getCity4;
                }
                this.getAddress4(2,str)
            }, 25);
        },
        //区
        'shopStorePayHuilian.huilianMerch.acqBankCityId'(id) {
            if(!id){
                return;
            }
            let str = ""
            for (let i = 0; i < this.cityIdList4.length; i++) {
                if(this.cityIdList4[i].code == id){
                    str = this.cityIdList4[i].id
                }
            }
            setTimeout(() => {
                if (!this.getArea4) {
                    this.shopStorePayHuilian.huilianMerch.acqBankAreaId = '';
                } else {
                    this.getArea4 = !this.getArea4;
                }
                this.getAddress4(3,str)
            }, 30);
        },
        tabs(val){
            // switch (val) {
            if(val == 'zero'){
                this.queryForm.thirdStatus='';
                this.currentPage = 1;
                this.getShopStorePayHuilianList();
                return
            }
            for (let i = 0; i < this.auditStatusList.length; i++) {
                if(val == 'status_'+i){
                    this.queryForm.thirdStatus = i;
                    this.currentPage = 1;
                    console.log(this.queryForm.thirdStatus)
                    this.getShopStorePayHuilianList();
                    break;
                }
            }
        },
    },
    data() {
        return {
            queryForm: {
                licenseName: '', //营业执照名称
                personName: '', //法人姓名
                personMobile: '', //法人手机
                thirdStatus: ''
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopStorePayHuilianState: 'add',
            shopStorePayHuilianStates: {
                add: '新建汇联进件',
                check: '查看汇联进件',
                edit: '修改汇联进件'
            },

            multipleSelection: [],
            shopStorePayHuilianList: [],
            shopStorePayHuilian: {
                userId: '', //用户id
                storeId: '', //门店id
                orgType: '', //组织类型：1个人2企业 3个体
                licensePic: '', //营业执照图片
                licenseName: '', //营业执照名称
                licenseNumber: '', //统一社会信用代码
                licenseRegCapital: '',//营业执照注册资本
                licenseProvinceId: '', //营业执照注册省份
                licenseCityId: '', //营业执照注册城市
                licenseAreaId: '', //营业执照注册区域
                licenseTownId: '', //营业执照注册社区
                licenseAddress: '', //营业执照注册地址
                licenseIsPermanent: '', //营业执照是否长期有效：1是 0否
                licenseStartTime: '', //营业执照有效开始日期
                licenseEndTime: '', //营业执照有效结束日期
                licenseRange: '', //营业执照经营范围
                personName: '', //法人姓名
                personMobile: '', //法人手机
                idCard: '', //身份证号
                idCardIsPermanent: '', //身份证是否长期有效：1是 0否
                idCardStartTime: '', //身份证有效限期起始日期
                idCardEndTime: '', //身份证有效期限截止日期
                idCardFacade: '', //身份证正面图片
                idCardBack: '', //身份证背面图片
                idCardAddress: '', //身份证地址
                bankAccount: '', //银行账号
                bankHolder: '', //银行户主
                bankMobile: '', //银行预留手机号码
                bankCardFacade: '', //银行卡正面图片
                bankCardBack: '', //银行卡背面图片
                bankAccountVoucher: '', //对公账户凭证
                bankName: '', //银行名称
                bankBranchCode: '', //行联号
                bankCode: '', //行联号
                bankSubbranch: '', //开户支行名称
                bankProvinceId: '', //开户银行省份
                bankCityId: '', //开户银行城市
                bankAreaId: '', //开户银行区县
                bankTownId: '', //开户银行社区
                isSign: '', //是否签名 0否 1是
                signPic: '', //签名图片
                contractUrl: '', //合同地址
                otherInfor: '', //其他补充资料：根据行业补充资料也不同，如烟酒店需要烟草经营许可证-废弃
                huilianMerch: {
                    mccCode: '',
                    mccName: '',
                    acqProvinceId: '',
                    acqCityId: '',
                    acqAreaId: '',
                    thirdStatus: 0,
                    acqBankProvinceId: '',
                    acqBankCityId: '',
                    acqBankAreaId: '',
                    acqBankName: '',
                    acqBankCode: '',
                    acqPortalAccount: '',
                    acqPortalEmail: '',
                    elecAgrmtUrl: '',
                }
            },
            btnLoading: false,

            rules: {
                "huilianMerch.storeId": [{ required: true, message: '门店id不能为空', trigger: 'blur' }],
                "huilianMerch.orginfoId": [{ required: true, message: '资料id不能为空', trigger: 'blur' }],
                "huilianMerch.mccCode": [{ required: true, message: '行业代码不能为空', trigger: 'blur' }],
                "huilianMerch.mccName": [{ required: true, message: '行业名称不能为空', trigger: 'blur' }],
                "huilianMerch.acqProvinceId": [{ required: true, message: '收单机构对应的省不能为空', trigger: 'blur' }],
                "huilianMerch.acqCityId": [{ required: true, message: '收单机构对应的市不能为空', trigger: 'blur' }],
                "huilianMerch.acqAreaId": [{ required: true, message: '收单机构对应的区不能为空', trigger: 'blur' }],
                "huilianMerch.thirdStatus": [{ required: true, message: '进件状态不能为空', trigger: 'blur' }],
                "huilianMerch.acqBankProvinceId": [{ required: true, message: '收单机构银行对应的省不能为空', trigger: 'blur' }], //收单机构对应的省
                "huilianMerch.acqBankCityId": [{ required: true, message: '收单机构银行对应的市不能为空', trigger: 'blur' }], //收单机构对应的市
                "huilianMerch.acqBankAreaId": [{ required: true, message: '收单机构银行对应的区不能为空', trigger: 'blur' }], //收单机构对应的区
                "huilianMerch.acqBankName": [{ required: true, message: '收单机构银行对应的市不能为空', trigger: 'blur' }],
                "huilianMerch.acqBankCode": [{ required: true, message: '收单机构银行对应的市不能为空', trigger: 'blur' }],
                "huilianMerch.acqPortalAccount": [{ required: true, message: '收单机构门户网站账号不能为空', trigger: 'blur' }],
                "huilianMerch.acqPortalEmail": [{ required: true, message: '收单机构门户网站账号邮箱不能为空', trigger: 'blur' }],


                "orgType": [{ required: true, message: '组织类型 1小微 2企业 3个体不能为空', trigger: 'blur' }],
                "licensePic": [{ required: true, message: '营业执照图片不能为空', trigger: 'blur' }],
                "licenseProvinceId": [{ required: true, message: '营业执照省不能为空', trigger: 'blur' }],
                "licenseCityId": [{ required: true, message: '营业执照市不能为空', trigger: 'blur' }],
                "licenseAreaId": [{ required: true, message: '营业执照区不能为空', trigger: 'blur' }],
                "licenseTownId": [{ required: true, message: '营业执照乡镇不能为空', trigger: 'blur' }],
                "licenseName": [{ required: true, message: '营业执照名称不能为空', trigger: 'blur' }],
                "licenseAddress": [{ required: true, message: '营业执照地址不能为空', trigger: 'blur' }],
                "licenseNumber": [{ required: true, message: '社会统一信用代码不能为空', trigger: 'blur' }],
                "licenseRegCapital": [{ required: true, message: '营业执照注册资本不能为空', trigger: 'blur' }],
                "licenseStartTime": [{ required: true, message: '营业执照有效开始日期不能为空', trigger: 'blur' }],
                "licenseEndTime": [{ required: true, message: '营业执照有效结束日期不能为空', trigger: 'blur' }],
                "licenseRange": [{ required: true, message: '营业执照经营范围不能为空', trigger: 'blur' }],
                "personName": [{ required: true, message: '法人姓名不能为空', trigger: 'blur' }],
                "personMobile": [{ required: true, message: '法人手机号不能为空', trigger: 'blur' }],
                "idCard": [{ required: true, message: '身份证号不能为空', trigger: 'blur' }],
                "idCardStartTime": [{ required: true, message: '身份证有效开始日期不能为空', trigger: 'blur' }],
                "idCardEndTime": [{ required: true, message: '身份证有效结束日期不能为空', trigger: 'blur' }],
                "idCardFacade": [{ required: true, message: '身份证正面图片不能为空', trigger: 'blur' }],
                "idCardBack": [{ required: true, message: '身份证背面图片不能为空', trigger: 'blur' }],
                "idCardAddress": [{ required: true, message: '身份证地址不能为空', trigger: 'blur' }],
                "bankAccount": [{ required: true, message: '银行账号不能为空', trigger: 'blur' }],
                "bankHolder": [{ required: true, message: '银行卡持有人不能为空', trigger: 'blur' }],
                "bankMobile": [{ required: true, message: '银行预留手机号不能为空', trigger: 'blur' }],
                "bankCardFacade": [{ required: true, message: '银行卡正面图片不能为空', trigger: 'blur' }],
                "bankCardBack": [{ required: true, message: '银行卡背面图片不能为空', trigger: 'blur' }],
                "bankAccountVoucher": [{ required: true, message: '对公账户凭证不能为空', trigger: 'blur' }],
                "bankName": [{ required: true, message: '银行名称不能为空', trigger: 'blur' }],
                "bankSubbranch": [{ required: true, message: '开户支行名称不能为空', trigger: 'blur' }],
                "bankProvinceId": [{ required: true, message: '开户行省不能为空', trigger: 'blur' }],
                "bankCityId": [{ required: true, message: '开户行市不能为空', trigger: 'blur' }],
                "bankAreaId": [{ required: true, message: '开户行市不能为空', trigger: 'blur' }],
                "bankTownId": [{ required: true, message: '开户行乡镇不能为空', trigger: 'blur' }],
                "bankBranchCode": [{ required: true, message: '银行行号不能为空', trigger: 'blur' }]
            },

            provinceIdList: [], //省信息
            cityIdList: [], //市信息
            areaIdList: [], //区信息
            streetIdList: [],
            getCity: false,//区别是不是get来的
            getArea: false,//区别是不是get来的
            street: false,

            cityIdList2: [], //市信息
            areaIdList2: [], //区信息
            streetIdList2: [],
            getCity2: false,//区别是不是get来的
            getArea2: false,//区别是不是get来的
            street2: false,

            getCity3: false,
            getArea3: false,
            provinceIdList3: [],
            cityIdList3: [],
            areaIdList3: [],

            getCity4: false,
            getArea4: false,
            cityIdList4: [],
            areaIdList4: [],

            storeOrgTypeStatusEunmList: [],
            auditStatusEnumList: [],
            auditStatusList: [],

            header: {
                token: localStorage.getItem('token')
            },
            action: UPLOAD_API + UPLOAD_PATH,
            imageSrc: '',
            srcList: [""],

            retreatDialogVisible: false,
            auditId: '',
            applyRemarks: '',
            retreatRules: {
                desc: [{ required: true, message: '请填写拒绝原因', trigger: 'blur' }],
                incomeRatio: [{ required: true, message: '请填写门店收益比例', trigger: 'blur' }],
                resource: [{ required: true, message: '请选择是否同意', trigger: 'change' }],
            },
            USER_code: USER,
            USER_search: USER_SEARCH,
            retreatForm: {
                resource: '',
                desc: '',
                incomeRatio: ''
            },
            fullscreenLoading: false,
            tabs: 'zero',
        };
    },
    created() {
        this.getShopStorePayHuilianList();
        this.getEnum();
        this.getAddress(1);
        this.getAddress3(1, "0");
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        radioThis(item){
            console.log( item)
            this.shopStorePayHuilian.huilianMerch.mccCode = item.id
            this.shopStorePayHuilian.huilianMerch.mccName = item.name
        },
        getMccCode(){
            get("/shop/yishengmcc/findAll").then((res)=>{
                if(res.success){
                    this.mccCodeList = res.list;
                    this.$nextTick(()=>{
                        this.$refs.mccCode.init(this.mccCodeList)
                    })
                }
            })
        },
        getSearchValueUser(val){
            this.queryForm.userId = val;
        },
        returnStoreOrgTypeStatus(key){
            for (let i = 0; i < this.storeOrgTypeStatusEunmList.length; i++) {
                if(this.storeOrgTypeStatusEunmList[i].key == key){
                    return this.storeOrgTypeStatusEunmList[i].value
                }
            }
        },
        // 获取对应地址
        getAddress(type, id=null) {
            get("/mpp/utils/findAreaList",{areaType:type,pid:id}).then((res)=>{
                if(res.success){
                    let array = []
                    for (let listElement of res.list) {
                        listElement.id = String(listElement.id)
                        array.push(listElement)
                    }
                    if(type == 1){
                        this.provinceIdList = array
                    }else if(type == 2){
                        this.cityIdList = array
                    }else if(type == 3){
                        this.areaIdList = array
                    }else if(type == 4){
                        this.streetIdList = array
                    }
                }
            })
        },
        // 获取对应地址
        getAddress2(type, id=null) {
            get("/mpp/utils/findAreaList",{areaType:type,pid:id}).then((res)=>{
                if(res.success){
                    let array = []
                    for (let listElement of res.list) {
                        listElement.id = String(listElement.id)
                        array.push(listElement)
                    }
                    if(type == 2){
                        this.cityIdList2 = array
                    }else if(type == 3){
                        this.areaIdList2 = array
                    }else if(type == 4){
                        this.streetIdList2 = array
                    }
                }
            })
        },
        // 获取对应地址
        getAddress3(type, id=null) {
            get("/shop/yishengarea/findAll",{
                prCode: id
            }).then((res)=>{
                if(res.success){
                    let array = []
                    for (let listElement of res.list) {
                        listElement.id = String(listElement.id)
                        array.push(listElement)
                    }
                    if(type == 1){
                        this.provinceIdList3 = array
                    }else if(type == 2){
                        this.cityIdList3 = array
                    }else if(type == 3){
                        this.areaIdList3 = array
                    }
                }
            })
        },
        // 获取对应地址
        getAddress4(type, id=null) {
            get("/shop/yishengarea/findAll",{
                prCode: id
            }).then((res)=>{
                if(res.success){
                    let array = []
                    for (let listElement of res.list) {
                        listElement.id = String(listElement.id)
                        array.push(listElement)
                    }
                    if(type == 1){
                        this.provinceIdList4 = array
                    }else if(type == 2){
                        this.cityIdList4 = array
                    }else if(type == 3){
                        this.areaIdList4 = array
                    }
                }
            })
        },
        // 获取枚举
        getEnum(){
            get('/shop/utils/getEnum',{
                enumType: "store_org_type_status"
            }).then((res)=>{
                if(res.success){
                    this.storeOrgTypeStatusEunmList = res.enumList;
                }
            })

            get('/shop/utils/getEnum', {
                enumType: 'huilian_register_merchant_status'
            }).then((res) => {
                if(res.success){
                    this.auditStatusList = res.enumList;
                }
            });
        },
        computeAuditStatus(key){
            for (let i = 0; i < this.auditStatusList.length; i++) {
                if(this.auditStatusList[i].key == key){
                    return this.auditStatusList[i].value
                }
            }
        },
        resetShopStorePayHuilianList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopStorePayHuilianList = [];
        },
        resetDialog() {
            this.shopStorePayHuilianState = 'add';
            this.showDialog = false;
            this.queryForm = {
                licenseName: '', //营业执照名称
                personName: '', //法人姓名
                personMobile: '', //法人手机
                thirdStatus: ''
            };
            this.getShopStorePayHuilianList();
        },
        closeDialog() {
            this.showDialog = false;
            this.shopStorePayHuilian = {
                userId: '', //用户id
                storeId: '', //门店id
                orgType: '', //组织类型：1个人2企业 3个体
                licensePic: '', //营业执照图片
                licenseName: '', //营业执照名称
                licenseNumber: '', //统一社会信用代码
                licenseRegCapital: '',//营业执照注册资本
                licenseProvinceId: '', //营业执照注册省份
                licenseCityId: '', //营业执照注册城市
                licenseAreaId: '', //营业执照注册区域
                licenseTownId: '', //营业执照注册社区
                licenseAddress: '', //营业执照注册地址
                licenseIsPermanent: '', //营业执照是否长期有效：1是 0否
                licenseStartTime: '', //营业执照有效开始日期
                licenseEndTime: '', //营业执照有效结束日期
                licenseRange: '', //营业执照经营范围
                personName: '', //法人姓名
                personMobile: '', //法人手机
                idCard: '', //身份证号
                idCardIsPermanent: '', //身份证是否长期有效：1是 0否
                idCardStartTime: '', //身份证有效限期起始日期
                idCardEndTime: '', //身份证有效期限截止日期
                idCardFacade: '', //身份证正面图片
                idCardBack: '', //身份证背面图片
                idCardAddress: '', //身份证地址
                bankAccount: '', //银行账号
                bankHolder: '', //银行户主
                bankMobile: '', //银行预留手机号码
                bankCardFacade: '', //银行卡正面图片
                bankCardBack: '', //银行卡背面图片
                bankAccountVoucher: '', //对公账户凭证
                bankName: '', //银行名称
                bankBranchCode: '', //行联号
                bankCode: '', //行联号
                bankSubbranch: '', //开户支行名称
                bankProvinceId: '', //开户银行省份
                bankCityId: '', //开户银行城市
                bankAreaId: '', //开户银行区县
                bankTownId: '', //开户银行社区
                isSign: '', //是否签名 0否 1是
                signPic: '', //签名图片
                contractUrl: '', //合同地址
                otherInfor: '', //其他补充资料：根据行业补充资料也不同，如烟酒店需要烟草经营许可证-废弃
                huilianMerch: {
                    mccCode: '',
                    mccName: '',
                    acqProvinceId: '',
                    acqCityId: '',
                    acqAreaId: '',
                    thirdStatus: 0,
                    acqBankProvinceId: '',
                    acqBankCityId: '',
                    acqBankAreaId: '',
                    acqBankName: '',
                    acqBankCode: '',
                    acqPortalAccount: '',
                    acqPortalEmail: '',
                }
            };
        },
        submitForm() {
            let params = { ...this.shopStorePayHuilian };
            delete params.store

            if (this.shopStorePayHuilianState == 'add') {
                this.$refs.shopStorePayHuilianForm.validate((valid, obj) => {
                    if (valid) {
                        console.log('submit');
                        post(`/shop/storepayHuilian/add`, params).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopStorePayHuilianList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }else{
                        this.$message({
                            dangerouslyUseHTMLString: true,
                            message: this.mergeErrorArrays(obj),
                            type: 'warning',
                            duration: 2000
                        });
                    }
                });
            } else if (this.shopStorePayHuilianState == 'edit') {
                this.$refs.shopStorePayHuilianForm.validate((valid, obj) => {
                    if (valid) {
                        console.log('submit');
                        delete params.licenseProvince
                        delete params.licenseCity
                        delete params.licenseArea
                        delete params.licenseTown
                        delete params.bankProvince
                        delete params.bankCity
                        delete params.bankArea
                        delete params.bankTown
                        postJson(`/shop/storepayhuilian/editHuilianData`, params).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopStorePayHuilianList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }else{
                        this.$message({
                            dangerouslyUseHTMLString: true,
                            message: this.mergeErrorArrays(obj),
                            type: 'warning',
                            duration: 2000
                        });
                    }
                });
            }
        },
        // 合并所有错误数组的方法
        mergeErrorArrays(errorObj) {
            let errors = [];
            // 遍历错误对象的所有属性
            for (const field in errorObj) {
                if (errorObj.hasOwnProperty(field) && Array.isArray(errorObj[field])) {
                    errors = errors.concat(errorObj[field]);
                }
            }
            return errors.map(item => item.message).join('<br>');
        },
        addShopStorePayHuilian() {
            this.showDialog = true;
            this.shopStorePayHuilianState = 'add';
        },
        checkShopStorePayHuilian(shopStorePayHuilianId) {
            console.log(shopStorePayHuilianId);
            this.currentShopStorePayHuilianId = shopStorePayHuilianId;

            this.getShopStorePayHuilianById();
            this.showDialog = true;
            this.shopStorePayHuilianState = 'check';
        },
        editShopStorePayHuilian(shopStorePayHuilianId) {
            console.log('shopStorePayHuilian', shopStorePayHuilianId);
            if (shopStorePayHuilianId) {
                this.currentShopStorePayHuilianId = shopStorePayHuilianId;
                this.getShopStorePayHuilianById();
            } else {
                this.shopStorePayHuilian = { ...this.shopStorePayHuilian, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.shopStorePayHuilianState = 'edit';
        },
        deleteShopStorePayHuilian(shopStorePayHuilianId) {
            let ids = '';
            if (shopStorePayHuilianId) {
                ids = shopStorePayHuilianId;
            } else {
                ids = this.multipleSelection.map((shopStorePayHuilian) => shopStorePayHuilian.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/storepayHuilian/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopStorePayHuilianList();
                            this.getShopStorePayHuilianList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshShopStorePayHuilianList() {
            this.resetShopStorePayHuilianList();
            this.getShopStorePayHuilianList();
        },
        getShopStorePayHuilianList(query = {}) {
            this.loading = true;
            get(`/shop/storepayhuilian/findHuilianStoreList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.shopStorePayHuilianList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getShopStorePayHuilianById() {
            get(`/shop/storepayhuilian/getHuilianStore`, { id: this.currentShopStorePayHuilianId }).then((res) => {
                if (res.success) {
                    this.shopStorePayHuilian = { ...this.shopStorePayHuilian, ...res.shopStoreInfo };
                    if(this.shopStorePayHuilian.huilianMerch == null){
                        this.shopStorePayHuilian.huilianMerch = {
                            mccCode: '',
                            mccName: '',
                            acqProvinceId: '',
                            acqCityId: '',
                            acqAreaId: '',
                            thirdStatus: 0,
                            acqBankProvinceId: '',
                            acqBankCityId: '',
                            acqBankAreaId: '',
                            acqBankName: '',
                            acqBankCode: '',
                            acqPortalAccount: '',
                            acqPortalEmail: '',
                        }
                    }
                    this.getCity = true;
                    this.getArea = true;
                    this.street = true;
                    this.getCity2 = true;
                    this.getArea2 = true;
                    this.street2 = true;

                    this.getCity3 = true;
                    this.getArea3 = true;

                    this.getCity4 = true;
                    this.getArea4 = true;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        /**
         * 导出信息
         */
        exportShopStorePayHuilianList() {
            //this.btnLoading = true;
            exprotExcel(`/shop/storepayHuilian/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/shop/storepayHuilian/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/shop/storepayHuilian/importData`, formData);
            this.refreshShopStorePayHuilianList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopStorePayHuilianList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopStorePayHuilianList();
        },
        beforeImageUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 50;
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 50MB!');
            }
            return isLt2M;
        },
        uploadImage21(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStorePayHuilian.licensePic = res.url;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        uploadImage31(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStorePayHuilian.idCardFacade = res.url;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        uploadImage32(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStorePayHuilian.idCardBack = res.url;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        uploadImage41(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStorePayHuilian.bankCardFacade = res.url;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        uploadImage42(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStorePayHuilian.bankCardBack = res.url;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        uploadImage43(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStorePayHuilian.bankAccountVoucher = res.url;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        uploadImage52(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStorePayHuilian.wxpayConfirmQrcode = res.url;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        uploadImage53(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStorePayHuilian.alipayApplyQrcode = res.url;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        uploadImage54(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStorePayHuilian.alipayConfirmQrcode = res.url;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        uploadImage61(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStorePayHuilian.signPic = res.url;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        uploadImage62(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStorePayHuilian.contractUrl = res.url;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        getImage(url){
            this.imageSrc = url;
            this.srcList[0] = url;
            this.$refs.images.showViewer = true;
        },
        // 大图预览
        updateSrcList(src) {
            this.srcList[0] = src
        },
        ShopStoreAudit(item) {
            console.log('applyRemarks', item);
            this.retreatDialogVisible = true;
            this.auditId = item.store.id;
            this.applyRemarks = item.store.remarks;
            this.retreatForm.desc = '';
        },
        // 审核取消按钮
        handleCloseRetreat() {
            this.retreatDialogVisible = false;
            this.auditId = '';//关闭后清除点击的id
            this.applyRemarks = ''; //关闭后清除申请人的说明
            this.retreatForm.resource = '';//关闭后把选择的按钮置空
            this.retreatForm.desc = '';
            this.retreatForm.incomeRatio = '';
            console.log(this.retreatForm)
        },
        //审核确认按钮
        retreatSuccess(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    //处理选择同意&拒绝
                    this.retreatDialogVisible = false;
                    let status = 1;
                    this.retreatForm.resource == 'true' ? status = 2 : status = 3;
                    get(`/shop/store/auditStore`, {
                        id: this.auditId,
                        status: status,
                        refuseReason: this.retreatForm.desc,
                        incomeRatio: this.retreatForm.incomeRatio
                    }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.handleCloseRetreat();
                            this.getShopStorePayHuilianList()
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                }
            });
        },

        // 获取默认系统邮箱
        getStoreEmail(){
            if(this.shopStorePayHuilian.huilianMerch.thirdStatus == 0){
                get("/shop/utils/getStorePublicEmail").then((res)=>{
                    if(res.success){
                        this.shopStorePayHuilian.huilianMerch.acqPortalEmail = res.email
                    }
                })
            } else {
                this.$message.error("当前状态不可操作")
            }
        },

        // 行别选择器
        getAcqBankNameId(e){
            this.shopStorePayHuilian.huilianMerch.acqBankCode = e.id
            this.shopStorePayHuilian.huilianMerch.acqBankName = e.bankName
        },

        // 行联号查询
        getBankBranchCode(e){
            this.shopStorePayHuilian.bankBranchCode = e.id
            this.shopStorePayHuilian.bankSubbranch = e.bankName
        },

        // 提交进件
        submitMerchantInfo(storeId){
            this.$confirm('确认资料核对无误', '提示', {
                type: 'warning'
            }).then(() => {
                this.fullscreenLoading = true;
                get('/shop/storepayhuilian/submitMerchantInfo', {
                    storeId: storeId,
                }).then((res) => {
                    this.fullscreenLoading = false;
                    if(res.success){
                        this.$message.success(res.msg);
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            }).catch(() => {
            });
        },

        // 提交修改资料
        merchantBasicdataModify(storeId){
            this.$confirm('确认资料核对无误', '提示', {
                type: 'warning'
            }).then(() => {
                this.fullscreenLoading = true;
                get('/shop/storepayhuilian/merchantBasicdataModify', {
                    storeId: storeId,
                }).then((res) => {
                    this.fullscreenLoading = false;
                    if(res.success){
                        this.$message.success(res.msg);
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            }).catch(() => {
            });
        },

        // 非收单会员登记
        submitAcctAccount(storeId){
            this.$confirm('确认资料核对无误', '提示', {
                type: 'warning'
            }).then(() => {
                this.fullscreenLoading = true;
                get('/shop/storepayhuilian/submitAcctAccount', {
                    storeId: storeId,
                }).then((res) => {
                    this.fullscreenLoading = false;
                    if(res.success){
                        this.$message.success(res.msg);
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            }).catch(() => {
            });
        },

        // 非收单会员登记信息变更
        editAcctAccount(){
            this.$confirm('确认资料核对无误', '提示', {
                type: 'warning'
            }).then(() => {
                this.fullscreenLoading = true;
                get('/shop/storepayhuilian/editAcctAccount', {
                    storeId: storeId,
                }).then((res) => {
                    this.fullscreenLoading = false;
                    if(res.success){
                        this.$message.success(res.msg);
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            }).catch(() => {
            });
        },

        // 微信实名认证
        wxAuthentication(storeId){
            this.$confirm('确认提交微信实名认证申请？', '提示', {
                type: 'warning'
            }).then(() => {
                this.fullscreenLoading = true;
                get('/shop/storepayhuilian/wxAuthentication', {
                    storeId: storeId,
                }).then((res) => {
                    this.fullscreenLoading = false;
                    if(res.success){
                        this.$message.success(res.msg);
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            }).catch(() => {
            });
        },

        // 支付宝实名认证
        aliAuthentication(storeId){
            this.$confirm('确认提交支付宝实名认证申请？', '提示', {
                type: 'warning'
            }).then(() => {
                this.fullscreenLoading = true;
                get('/shop/storepayhuilian/aliAuthentication', {
                    storeId: storeId,
                }).then((res) => {
                    this.fullscreenLoading = false;
                    if(res.success){
                        this.$message.success(res.msg);
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            }).catch(() => {
            });
        },

        // 申请合同
        applyElectronContract(storeId){
            this.$confirm('确认申请电子协议', '提示', {
                type: 'warning'
            }).then(() => {
                this.fullscreenLoading = true;
                get('/shop/storepayHuilian/applyElectronContract', {
                    storeId: storeId,
                }).then((res) => {
                    this.fullscreenLoading = false;
                    if(res.success){
                        this.$message.success(res.msg);
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            }).catch(() => {
            });
        },

        // 开通分账
        openMerchantSplitOrder(storeId){
            this.$confirm('确认开通分账业务', '提示', {
                type: 'warning'
            }).then(() => {
                this.fullscreenLoading = true;
                get('/shop/storepayHuilian/openMerchantSplitOrder', {
                    storeId: storeId,
                }).then((res) => {
                    this.fullscreenLoading = false;
                    if(res.success){
                        this.$message.success(res.msg);
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            }).catch(() => {
            });
        }
    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    button {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
.content{
    background-color: #fff;
    padding: 10px;
    height: 100%;
}

.avatar {
    width: 130px;
    height: 130px;
    display: block;
}

::v-deep .el-upload--text {
    width: 130px;
    height: 130px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

::v-deep .el-range-separator {
    width: 20px;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 130px;
    height: 130px;
    line-height: 130px;
    text-align: center;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}


.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}

.page-content{
    height: 93%;
    padding: 0;
    border: 0;
}

.flex{
    display: flex;
    align-items: center;
    justify-content: center;
}
.active{
    color:#67C23A;
}
</style>